import axios, { AxiosRequestConfig } from 'axios';
import cookies from 'js-cookie';

export default async function APIClient(method, url, params?, data?, headers?, files?, fields?) {
   let request: AxiosRequestConfig = {
      withCredentials: true,
      url: url,
      method: method
   };

   if (params) {
      request.params = params;
   }

   if (headers) {
      request.headers = headers;
   }

   const cookie = cookies.get('em_at');

   if (cookie) {
      request.headers = {
         Authorization: `Bearer ${cookie}`
      };
   }

   if (data) {
      request.data = data;
   }

   // Not sure if these are still necessary. Don't match up with Axios Request Fields
   // if (files) {
   //   files.forEach(file => request.attach(file.key, file.value));
   // }

   // if (fields) {
   //   fields.forEach(item => request.field(item.key, item.value));
   // }

   return await axios.request(request);
}
